export const extractImportableAndErrorLocations = async ({
  parsedLocations,
  geocoder,
}) => {
  // フォーマットに合致しているものを取得
  const formattedLocations = parsedLocations.filter(
    location =>
      location.locationGroupName && location.locationName && location.address,
  )
  // フォーマット外のlocationデータをエラーデータのリストとして取得
  const notFormattedLocations = parsedLocations.filter(
    location =>
      !location.locationGroupName ||
      !location.locationName ||
      !location.address,
  )
  // ジオコーディングに失敗した地点のみlocationの情報を持つ形で取得
  const missGeocodingLocations = await Promise.all(
    formattedLocations.map(async location => {
      const result = await geocoder(location.address)
      if (result[0] === undefined) return location
    }),
  )
  // ジオコーディングに失敗した地点のみにfilter
  const geocodingErrorLocations = missGeocodingLocations.filter(
    location => location !== undefined,
  )
  // ジオコーディングに失敗した地点の住所を取得
  const errorAddresses = geocodingErrorLocations.map(location => {
    return location.address
  })
  // 正しいフォーマットのうちジオコーディングに失敗した地点のみにfilter
  const importableLocations = formattedLocations.filter(
    location => !errorAddresses.includes(location.address),
  )
  // フォーマット外のリストとジオコーディングに失敗したlocationデータを結合
  const errorLocations = notFormattedLocations.concat(geocodingErrorLocations)
  return {
    importableLocations: importableLocations,
    errorLocations: errorLocations,
  }
}
